module.exports = __webpack_public_path__ + "static/media/qingming4Bg.944d71fd.jpg";